import type { SlotApp } from "../../app/createSlotApp";
import type { CoreServices } from "../CoreServices";
import type { BootLoaderPort } from "../loader/BootLoaderPort";

/** The end of boot: the bet unlocked (never in replay mode), the loader gone, the hook marked ready after the next frame. */
export function finishBoot(
  services: Pick<CoreServices, "betSystem">,
  loader: BootLoaderPort | null,
  slot: SlotApp,
  hook: { markReady(): void } | null,
  options: { unlockBet: boolean } = { unlockBet: true },
): void {
  // Replay mode keeps the bet locked (`replay_mode`) for the life of the page.
  if (options.unlockBet) services.betSystem.unlock();
  loader?.dismiss();
  slot.app.ticker.addOnce(() => hook?.markReady());
}
